import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/admin/productions',
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/auth/callback',
      name: 'AuthCallback',
      component: () => import('../views/auth/AuthCallback.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/auth/qr-approve',
      name: 'QRApprove',
      component: () => import('../components/auth/QRCodeScanner.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/admin',
      name: 'Admin',
      redirect: '/admin/productions',
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/productions',
      name: 'Productions',
      component: () => import('../views/admin/Productions.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/productions/:id/theme',
      name: 'ProductionThemeEditor',
      component: () => import('../views/admin/ProductionThemeEditor.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/productions/:id/casts',
      name: 'Casts',
      component: () => import('../views/admin/Casts.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/productions/:id/actors',
      name: 'Actors',
      component: () => import('../views/admin/Actors.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/productions/:id/scenes',
      name: 'Scenes',
      component: () => import('../views/admin/Scenes.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/productions/:id/assignments',
      name: 'SceneAssignments',
      component: () => import('../views/admin/SceneAssignments.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/productions/:id/import',
      name: 'ImportCSV',
      component: () => import('../views/admin/ImportCSV.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/productions/:id/import-set-pieces',
      name: 'ImportSetPiecesCSV',
      component: () => import('../views/admin/ImportSetPiecesCSV.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/productions/:id/control',
      name: 'StageControl',
      component: () => import('../views/admin/StageControl.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/display/phone/:productionId',
      name: 'PhoneDisplay',
      component: () => import('../views/display/PhoneDisplay.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/display/tv/:productionId',
      name: 'TVDisplay',
      component: () => import('../views/display/TVDisplay.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      redirect: '/login',
    },
  ],
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('stage_direction_token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)

  if (requiresAuth && !token) {
    // Redirect to login if authentication is required
    next('/login')
  } else if (requiresAdmin && token) {
    // Verify admin status (in a real app, check JWT payload or API)
    const user = JSON.parse(localStorage.getItem('stage_direction_user') || '{}')
    if (user.role && ['admin', 'stage_manager'].includes(user.role)) {
      next()
    } else {
      // Not an admin, redirect to login
      next('/login')
    }
  } else if (to.path === '/login' && token) {
    // Already logged in, redirect to admin
    next('/admin/productions')
  } else {
    next()
  }
})

export default router
